module.exports = __webpack_public_path__ + "img/minecraft.7b355bae.png";